/* =============================================================
   arije - Bandeau de reassurance (pied de page)

   Le carrousel n'est initialise qu'a partir de 950px. En dessous,
   les libelles sont affiches en liste centree qui passe a la ligne
   (voir assets/reassurance-section.css) : plus aucun texte coupe
   aux bords de l'ecran.

   Le carrousel est detruit / recree au franchissement du seuil,
   pour que le passage portrait <-> paysage reste propre.
   ============================================================= */

window.addEventListener('DOMContentLoaded', function () {
  var el = document.querySelector('.swiper.reassurance__container');
  if (!el || typeof Swiper === 'undefined') return;

  var mq = window.matchMedia('(min-width: 950px)');
  var instance = null;

  function sync() {
    if (mq.matches && !instance) {
      instance = new Swiper(el, {
        slidesPerView: 5,
        allowTouchMove: false
      });
    } else if (!mq.matches && instance) {
      instance.destroy(true, true);
      instance = null;
    }
  }

  sync();

  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', sync);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(sync);
  }
});
